import { IRiskTemplateFormCondition } from 'types/graphql'

export const getShouldExecute = (
  condition: IRiskTemplateFormCondition,
  fieldValue: any,
) => {
  const { value: triggerValue } = condition.trigger

  if (typeof triggerValue === 'boolean') {
    return fieldValue === triggerValue
  }

  if (Array.isArray(fieldValue)) {
    return fieldValue.some(i => i.value === triggerValue)
  }

  return fieldValue?.value === triggerValue
}
